<mat-card>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel class="mb-3 mt-3" expanded hideToggle="true" disabled>
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title" style="color: black;">
                        {{ "history_report.title" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="form-group row">
                    <div class="col-12">
                        <span style="font-style: italic;"><strong>{{ "history_report.note" | translate }}</strong>{{ "history_report.note_message" | translate }}</span>
                    </div>
                </div>
                <div class="mat-table-container">
                    <mat-table [dataSource]="dataSource" matSort class="mat-table-col-extra-lg"
                        (matSortChange)="onChangeSort($event)">
                        <!-- STT -->
                        <ng-container matColumnDef="stt">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                {{"history_report.detail_table.index" | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element; let index = index"
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                {{pageIndex.pageSize * pageIndex.currentPage + index + 1}}
                            </mat-cell>
                        </ng-container>

                        <!-- tên báo cáo -->
                        <ng-container matColumnDef="reportName">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom ">
                                {{"history_report.detail_table.report_name" | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.name }}"
                                class="mat-cell-non-boder-right-bottom " (click)="$event.stopPropagation()"
                                >
                                <span class="fix-width text-center">{{ element.name ? element.name : ''}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- ngày xuất báo cáo -->
                        <ng-container matColumnDef="exportDate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 20%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{"history_report.detail_table.export_date" | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.createdTime | date:'dd/MM/yyyy HH:mm:ss'}}"
                                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                                style="max-width: 20%;">
                                <span class="fix-width text-center">{{ element.createdTime | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- kết quả xuất báo cáo -->
                        <ng-container matColumnDef="exportResult">
                            <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{"history_report.detail_table.export_result" | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-cell-non-boder-right-bottom mat-header-cell-center "
                                (click)="$event.stopPropagation()" style="max-width: 20%">
                                <span style="padding: 3px; width: 60%; text-align: center;"
                                    [ngStyle]="renderStatusColor(element.status)">{{
                                    renderStatus(element.status) }}</span>
                            </mat-cell>
                        </ng-container>

                        <!-- tác động -->
                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center">
                                {{"history_report.detail_table.action" | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                                class="number-cell-center">

                                <!-- Xem chi tiết -->
                                <button mat-icon-button (click)="viewFilterFile(element)"
                                    *ngIf="element.status === 3 || element.status === 2">
                                    <mat-icon matTooltip="{{'enterprise_contract.tooltips.export_view' | translate}}">
                                        visibility
                                    </mat-icon>
                                </button>
                                <!-- file rỗng -->
                                <button mat-icon-button *ngIf="element.status === 2 && element.isEmptyReport">
                                    <i class="fa fa-file-o" aria-hidden="true"
                                        matTooltip="{{'enterprise_customer_management.buttons.empty_file' | translate}}"></i>
                                </button>

                                <!-- tai lai -->
                                <button mat-icon-button *ngIf="element.status === 3" (click)="viewFilterFile(element.id, true)">
                                    <mat-icon
                                        matTooltip="{{'enterprise_contract.buttons.re_download' | translate}}">
                                        replay
                                    </mat-icon>
                                </button>

                                <!-- Tải xuống -->
                                <button mat-icon-button type="button" (click)="downloadContract(element.id, element.name)"
                                    *ngIf="element.status === 2 && !element.isEmptyReport">
                                    <mat-icon matTooltip="{{'enterprise_contract.buttons.download_export' | translate}}">
                                        save_alt
                                    </mat-icon>
                                </button>

                                <!-- Xóa -->
                                <button mat-icon-button (click)="deleteContract(element.id, element.name)"
                                    *ngIf="element.status === 2">
                                    <i class="fa fa-trash" aria-hidden="true"
                                        matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                                </button>

                                <!-- warning -->
                                <button mat-icon-button *ngIf="element.status === 3">
                                    <i class="fa fa-warning text-danger" aria-hidden="true"
                                        matTooltip="{{element.errorMessage}}"></i>
                                </button>
                            </mat-cell>
                        </ng-container>
                      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                      <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                               (toggleChange)="onToggleChange($event,row)">
                      </mat-row>
<!--                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>-->
<!--                        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"-->
<!--                            [cdkDetailRow]="row">-->
<!--                        </mat-row>-->
                    </mat-table>
                </div>
                <!-- Pagination -->
                <app-pagination [(paginate)]="paginate" (pageChange)="onChangePage($event)">
                </app-pagination>
                <!-- /Pagination -->
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
</mat-card>
